module.exports = __webpack_public_path__ + "img/E-WEB-Goal-2.06ab3f40.png";